var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimesCircle = function SvgTimesCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.6C8.2 1.6 1.6 8.2 1.6 16S8 30.4 16 30.4 30.4 24 30.4 16 23.8 1.6 16 1.6m0 24.8c-5.6 0-10.4-4.6-10.4-10.4S10.4 5.6 16 5.6 26.4 10.2 26.4 16 21.6 26.4 16 26.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 10.6c-.8-.8-2-.8-2.8 0L16 13.2l-2.6-2.6c-.8-.8-2-.8-2.8 0s-.8 2 0 2.8l2.6 2.6-2.6 2.6c-.8.8-.8 2 0 2.8s2 .8 2.8 0l2.6-2.6 2.6 2.6c.8.8 2 .8 2.8 0s.8-2 0-2.8L18.8 16l2.6-2.6c.8-.8.8-2 0-2.8"
  })));
};
export default SvgTimesCircle;